module.exports = __webpack_public_path__ + "img/pr-4.560f3948.png";